var map = {
	"./partner_id_1.png": 3276,
	"./partner_id_10.png": 20162,
	"./partner_id_2.png": 84753,
	"./partner_id_3.png": 52354,
	"./partner_id_4.png": 40950,
	"./partner_id_5.png": 4074,
	"./partner_id_6.png": 18399,
	"./partner_id_7.png": 91455,
	"./partner_id_8.png": 53031,
	"./partner_id_9.png": 30747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73490;